var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.347,
    height: 29.461,
    viewBox: "0 0 27.347 29.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6314",
    "data-name": "Rectangle 6314",
    width: 27.348,
    height: 29.461,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22648",
    "data-name": "Group 22648",
    transform: "translate(3523 19087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36101",
    "data-name": "Path 36101",
    d: "M-3516.925-19064.437c-2.25-.449,16.2-.15,17.6,0s3.05,1,3.05,2.8a3.183,3.183,0,0,1-1.75,3.1c-1,.65-20.05.549-20.05.549l.22-.309C-3517.636-19058.59-3513.775-19060.387-3516.925-19064.437Z",
    fill: "#2bc7c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22647",
    "data-name": "Group 22647",
    transform: "translate(-3523 -19087)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36090",
    "data-name": "Path 36090",
    d: "M0,13.192Q0,6.924,0,.656C0,.2.2,0,.661,0H21.868c.486,0,.682.194.682.674q0,10.491,0,20.982c0,.171.055.2.206.193a6.014,6.014,0,0,1,1.981.19,3.8,3.8,0,0,1-.426,7.335,3.949,3.949,0,0,1-.77.077c-6.558,0-13.115-.016-19.673.009A3.908,3.908,0,0,1,.043,26.113,4.751,4.751,0,0,1,0,25.462q0-6.135,0-12.27m6.526,15.13H7.1l16.238,0a3.365,3.365,0,0,0,.95-.106,2.681,2.681,0,0,0,1.26-4.334c-.092-.105-.253-.1-.313-.233a.538.538,0,0,0-.228-.226,2.756,2.756,0,0,0-1.545-.439q-6.279.006-12.557,0c-.1,0-.191,0-.286,0a.558.558,0,0,1-.554-.637c.04-.322.281-.5.677-.5q5.246,0,10.491,0c.122,0,.194,0,.194-.165q-.007-10.185,0-20.369c0-.166-.047-.2-.206-.2q-9.949.005-19.9,0c-.174,0-.212.052-.212.218q.006,11.994,0,23.988a4.72,4.72,0,0,0,.031.571,2.737,2.737,0,0,0,2.813,2.431A2.689,2.689,0,0,0,6.3,24.708a2.613,2.613,0,0,0-2.468-1.732.565.565,0,1,1,.005-1.127q2.27,0,4.54,0a.571.571,0,1,1,0,1.139c-.327,0-.654,0-.982,0H6.525a3.826,3.826,0,0,1,0,5.334",
    transform: "translate(0 0)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36092",
    "data-name": "Path 36092",
    d: "M64.164,78.188h.962a.563.563,0,0,0,.638.581c.374,0,.749.013,1.123,0,.154-.005.177.047.177.182q-.006,2.1,0,4.192c0,.147-.044.176-.183.175-1.07-.006-2.141,0-3.211,0H59.356c-.108,0-.188.011-.187-.152.008-1.411.007-2.822,0-4.233,0-.12.03-.162.161-.161,1.4.006,2.791,0,4.187.006a.578.578,0,0,0,.642-.585",
    transform: "translate(-48.152 -63.629)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36093",
    "data-name": "Path 36093",
    d: "M59.25,75.828a.578.578,0,0,1-.642.585c-1.4,0-2.792,0-4.187-.006-.131,0-.162.042-.161.161,0,1.411,0,2.822,0,4.233,0,.163.079.153.187.152h4.315c1.07,0,2.141,0,3.211,0,.138,0,.183-.028.183-.175q-.009-2.1,0-4.192c0-.135-.023-.187-.177-.182-.374.013-.749,0-1.123,0a.563.563,0,0,1-.638-.581c.1-.417.259-.538.687-.538.586,0,1.172,0,1.759,0a.564.564,0,0,1,.622.619q0,2.77,0,5.54a.574.574,0,0,1-.645.64c-2.965,0-5.93,0-8.895.006a.613.613,0,0,1-.609-.612c.013-1.676.009-3.353.01-5.029,0-.2-.007-.4,0-.592a.544.544,0,0,1,.58-.572c.607,0,1.213,0,1.82,0l3.026,0c.422,0,.608.147.686.541",
    transform: "translate(-43.239 -61.269)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36094",
    "data-name": "Path 36094",
    d: "M23.466,46.256h-7.73a.564.564,0,0,1-.616-.707.519.519,0,0,1,.432-.4,1.93,1.93,0,0,1,.263-.024H31.01a2.292,2.292,0,0,1,.326.012.541.541,0,0,1,.484.581.557.557,0,0,1-.542.532c-.054,0-.109,0-.163,0H23.466",
    transform: "translate(-12.289 -36.726)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36095",
    "data-name": "Path 36095",
    d: "M23.471,18.023H31.2a.568.568,0,1,1,.1,1.132,1.356,1.356,0,0,1-.143,0H15.761a.568.568,0,0,1-.643-.492.551.551,0,0,1,.384-.617.94.94,0,0,1,.3-.026h7.665",
    transform: "translate(-12.298 -14.667)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36096",
    "data-name": "Path 36096",
    d: "M23.452,59.809H15.743a.57.57,0,1,1,0-1.129H31.164c.4,0,.654.216.653.565s-.249.565-.657.565H23.452Z",
    transform: "translate(-12.287 -47.754)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36097",
    "data-name": "Path 36097",
    d: "M23.47,31.61h7.748a.557.557,0,0,1,.1,1.11c-.047,0-.1,0-.143,0q-7.717,0-15.435.005a.582.582,0,0,1-.637-.584.543.543,0,0,1,.534-.534c.157,0,.314,0,.47,0h7.36",
    transform: "translate(-12.293 -25.723)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36098",
    "data-name": "Path 36098",
    d: "M18.021,99.305h2.287a.571.571,0,1,1,0,1.133q-2.287,0-4.574,0a.55.55,0,0,1-.6-.467.556.556,0,0,1,.362-.632.758.758,0,0,1,.282-.034h2.246",
    transform: "translate(-12.307 -80.816)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36099",
    "data-name": "Path 36099",
    d: "M18.006,86.868c-.776,0-1.552,0-2.328,0a.559.559,0,0,1-.558-.392.568.568,0,0,1,.234-.644.628.628,0,0,1,.368-.1q2.3,0,4.595,0a.568.568,0,0,1,.609.571.556.556,0,0,1-.613.562q-1.154,0-2.308,0",
    transform: "translate(-12.285 -69.771)",
    fill: "#0d0d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36100",
    "data-name": "Path 36100",
    d: "M18.028,73.375c-.783,0-1.567,0-2.351,0a.533.533,0,0,1-.541-.433.555.555,0,0,1,.338-.646.545.545,0,0,1,.22-.035q2.34,0,4.681,0a.556.556,0,1,1,0,1.112c-.783,0-1.567,0-2.351,0",
    transform: "translate(-12.308 -58.806)",
    fill: "#0d0d0b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.921e18b1414d2a6f6e72d5800a5e1bd6.svg";
export { ForwardRef as ReactComponent };